import * as dot from 'dot-object';

export default class Permissions {
    public static AllPermissions: object;

    public static PermissionsLoaded() {
        return this.AllPermissions !== undefined;
    }

    public static LoadAllPermissions(rawPerms: string[]) {
        const permObj = {};
        rawPerms.forEach(value => {
            dot.str(value, false, permObj);
        });

        this.AllPermissions = permObj;
    }

    public static GetAllPermissions() {
        if (this.AllPermissions) {
            return this.AllPermissions;
        }
        throw new Error("No Permissions Loaded");
    }

    public static TransformPermissionsToString(permObj: any) {
        const permStringList = [] as string[];
        const permissions = dot.dot(permObj);
        for (const key in permissions) {
            if(permissions.hasOwnProperty(key)) {
                if(permissions[key] === true) {
                    permStringList.push('Permissions.' + key);
                }
            }
        }
        return permStringList;
    }

    public static AssignPermissions(rawPerms: string[]) {
        if (this.AllPermissions) {
            const myPermissions = JSON.parse(JSON.stringify(this.AllPermissions));
            rawPerms.forEach(value => {
                dot.str(value, true, myPermissions);
            });
            return myPermissions;
        }
    }

    public static GetPermissionStrings(permObj: object) {
        const permissions = dot.dot(permObj);
        const enabledPermissions = [];
        for (const key in permissions) {
            if (permissions.hasOwnProperty(key)) {
                if(permissions[key]) {
                    enabledPermissions.push(key);
                }
            }
        }
        return enabledPermissions;
    }
}


// WEBPACK FOOTER //
// ./src/Services/Permission/Permissions.ts